import { DimensionValueSet } from "@/lib/dimensions";

import { GetTileImageProps } from "./tiled-deck-gl-layer";
import { HttpCache } from "./http-cache";

export abstract class BaseTileImageLoader {
  private cache = new HttpCache("tile-image-loader_v1");

  async getCachedTileImage(dimensionValues: DimensionValueSet, props: GetTileImageProps) {
    const response = await this.cache.match(this.tileImageRequest(dimensionValues, props));
    if (!response) return;
    return await this.imageFromResponse(response);
  }

  async loadTileImage(dimensionValues: DimensionValueSet, props: GetTileImageProps) {
    props.signal?.throwIfAborted();

    const request = this.tileImageRequest(dimensionValues, props);
    const response = await fetch(request);

    if (!response.ok) throw new Error(response.statusText, { cause: response });

    await this.cache.put(request, response);
    return await this.imageFromResponse(response);
  }

  abstract tileImageRequest(
    dimensionValues: DimensionValueSet,
    props: GetTileImageProps,
  ): Request;

  private async imageFromResponse(response: Response) {
    const blob = await response.blob();
    const image = new Image();
    image.src = URL.createObjectURL(blob);
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = (event) => {
        reject({ message: "HTMLImageElement onerror", response, event });
      };
    });
    return image;
  }
}
